export default class Marquee {
    constructor() {
        this.marquee = document.querySelectorAll('.js-marquee')
        this.marquee.forEach((el) => {
          Marquee.calculateWith(el)
        })
    }
    static calculateWith(el) {
      const container = el
      const element = container.querySelectorAll('.marquee__line__content')
      let pageWidth = document.body.offsetWidth
      let containerWidth = container.offsetWidth
      const forAnim = element[0].cloneNode(true)
      container.appendChild(forAnim)
      containerWidth += forAnim.offsetWidth
      while (containerWidth < pageWidth * 2) {
        const newElement = element[0].cloneNode(true)
        container.appendChild(newElement)
        containerWidth += newElement.offsetWidth
      }

      el.classList.add('marquee--loaded')
    }
}
